// @flow
import { Error, FormFieldGroup, Input } from "./LoginPassword.styles";
import React from "react";

interface TextInputProps {
	register: any;
	name: string;
}

const TextInput = ({ register, value, name, onChange }: TextInputProps) => (
	<Input
		type="text"
		name={name}
		value={value}
		onChange={onChange}
		ref={register({ required: true })}
	></Input>
);

interface TextInputFieldProps {
	name: string;
	value: string;
	label: string;
	isValid: boolean;
	errorMessage: string;
	onChange: any;
}

export const TextInputField = ({
	name,
	value,
	isValid,
	label,
	errorMessage,
	onChange,
	visible,
}: TextInputFieldProps) => {
	if (!visible && typeof visible != "undefined") return null;
	return (
		<FormFieldGroup>
			<label>
				{label}
				{!isValid && <span className="error"> ({errorMessage})</span>}
			</label>
			<input
				placeholder={label}
				type="text"
				name={name}
				value={value}
				onChange={onChange}
			/>
		</FormFieldGroup>
	);
};

export default TextInput;
